export enum CallStatus {
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
}
